define(['../lang/isObject'], function(isObject) {

  /**
   * Converts `value` to an object if it is not one.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {Object} Returns the object.
   */
  function toObject(value) {
    return isObject(value) ? value : Object(value);
  }

  return toObject;
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-amd/modern/internal/toObject.js
// module id = 627
// module chunks = 0